import { useEffect, useState } from "react";
import "./App.css";
import Leaderboard from "./Leaderboard";

function Header() {
  return (
    <div
      style={{
        width: "100%",
        height: 243,
        fontWeight: 650,
        fontSize: "3rem",
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f7f7f9",
      }}
    >
      <span>Leaderboard</span>
      <span style={{ fontWeight: 400, fontSize: 14, marginTop: 10 }}>
        Leaderboard date is in UTC timezone.
      </span>
      <span style={{ fontWeight: 400, fontSize: 14 }}>
        Leaderboard is updated every day around UTC 3AM.
      </span>
    </div>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [dataExists, setDataExists] = useState(false);
  useEffect(() => {
    fetch(
      `https://cbridge-stat.s3.us-west-2.amazonaws.com/test/getCampaignScores_1.json`,
      {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((res) => {
        setIsLoading(false);
        setDataExists(res.ok);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
        setDataExists(false);
      });
    return () => {};
  }, []);
  return (
    <div className="App">
      <Header />
      {(() => {
        if (isLoading) {
          return null;
        } else {
          if (dataExists) {
            return <Leaderboard />;
          } else {
            return (
              <div
                style={{
                  height: 100,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span>No data yet.</span>
              </div>
            );
          }
        }
      })()}
    </div>
  );
}

export default App;
